module.exports = __webpack_public_path__ + "img/yan10.f531d5bb.png";